export const unitConvertion = ({ value, unit }) => {
  if (unit === 'cubic_meters') {
    return value / 1000;
  }
  if (unit === 'kilograms') {
    return value * 0.00133;
  }
  return value;
};